import { render, staticRenderFns } from "./modality-partial.vue?vue&type=template&id=51f96184"
import script from "./modality-partial.vue?vue&type=script&lang=js"
export * from "./modality-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports